import React from 'react'
import { Svg } from '../../../..'

export const ShareDefaultSvg = () => (
  <Svg width={192} height={81} viewBox='0 0 192 81' fill='none'>
    <path
      d='M191.22 32.063c0 33.5-77.981 44-131 44-53.02 0-73.937-12.5-51-44 37.5-51.5 55.98-25.5 109-25.5 53.019 0 73 6.5 73 25.5z'
      fill='#2D2B32'
      fillOpacity={0.5}
    />
    <path
      d='M94.155 21.07s-2.967 2.247 0 7.931c-7.747-2.065-8.26-7.93-8.26-7.93H71.14c-.576 0-1.129-.223-1.536-.618a2.08 2.08 0 01-.637-1.493V3.118c0-.277.055-.552.164-.81.108-.256.268-.49.47-.686.202-.197.442-.353.706-.46a2.23 2.23 0 01.833-.16h29.654c.286-.001.57.053.834.159.265.106.505.262.707.459a2.092 2.092 0 01.632 1.498v15.849a2.057 2.057 0 01-.637 1.49c-.202.195-.441.35-.705.456-.264.105-.546.159-.831.158H94.155z'
      fill='#F3EFF1'
      fillOpacity={0.1}
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M87.892 12.444a1.317 1.317 0 11-.002-2.634 1.317 1.317 0 01.002 2.634zm-4.275 0a1.317 1.317 0 11-.002-2.634 1.317 1.317 0 01.002 2.634zm-1.276 3.54H89.148a.856.856 0 00.857-.855v-1.45h.502a.461.461 0 00.461-.461v-1.862a.46.46 0 00-.462-.46h-.501V9.068a.856.856 0 00-.856-.854h-3.167v-.513a1.353 1.353 0 10-.485-.01v.523H82.34a.855.855 0 00-.855.854v1.826h-.51a.46.46 0 00-.46.46v1.863c0 .254.207.46.46.46h.51v1.45c0 .473.383.856.856.856zm.275-1.759c0-.311.252-.564.563-.564h5.27a.564.564 0 110 1.128h-5.27a.564.564 0 01-.564-.564z'
      fill='#F3EFF1'
    />
    <path
      d='M101.57 18.455v3.294h-8.124s-2.734 2.148 0 7.584c-3.44-.942-5.33-2.734-6.371-4.335v29.035h27.013V18.455H101.57zM96.892 66.551H88.9c-4.691 0-6.833-3.195-6.345-7.517.092-.751.315-1.48.659-2.155.158 1.503.659 4.092 2.681 5.535 1.819 1.317 3.954 1.04 5.93.876a68.723 68.723 0 0112.248.125l.521 2.754-7.307 3.677c2.24-.725 1.245-3.295-.395-3.295z'
      fill='#252328'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M102.22 13.52c0-.74.599-1.338 1.338-1.338h10.396a5.775 5.775 0 015.755 5.755v12.714a1.338 1.338 0 11-2.676 0V17.942a3.097 3.097 0 00-3.085-3.085h-10.39c-.739 0-1.338-.599-1.338-1.338zM83.451 21.406c.74 0 1.339.599 1.339 1.338v36.419a3.11 3.11 0 003.092 3.092h26.065a3.103 3.103 0 003.086-3.091v-7.089a1.338 1.338 0 112.676 0v7.095a5.78 5.78 0 01-5.753 5.762H87.873a5.786 5.786 0 01-5.76-5.76V22.744c0-.739.6-1.338 1.338-1.338z'
      fill='#9D97AB'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M105.968 63.269c.634.38.839 1.202.459 1.836-1.928 3.216-4.564 4.955-6.995 6.135a47.24 47.24 0 01-2.663 1.165c-.242.1-.475.195-.696.288-1.019.428-1.79.79-2.35 1.195a1.338 1.338 0 01-1.569-2.168c.837-.606 1.87-1.07 2.883-1.495.252-.106.506-.21.76-.315a43.39 43.39 0 002.466-1.078c2.168-1.052 4.305-2.495 5.869-5.103a1.338 1.338 0 011.836-.46zM83.22 24.881c.77.725 1.262 1.772 1.421 3.047a1.338 1.338 0 01-2.656.331c-.098-.784-.369-1.212-.6-1.43a.966.966 0 00-.73-.28c-.438.025-1.103.41-1.116 1.558-.046 4.789-1.724 8.994-3.106 12.427l-.05.126c-.685 1.699-1.275 3.164-1.626 4.49-.36 1.351-.42 2.387-.171 3.223.076.245.175.553.29.908.358 1.113.868 2.695 1.287 4.288.28 1.06.529 2.162.675 3.182.142.994.205 2.025.033 2.892a1.338 1.338 0 01-2.626-.52c.083-.415.073-1.086-.057-1.992-.126-.879-.348-1.872-.613-2.881-.398-1.513-.87-2.975-1.227-4.085-.123-.381-.233-.721-.322-1.007l-.004-.013c-.455-1.525-.265-3.127.147-4.682.395-1.49 1.041-3.093 1.697-4.72l.084-.21c1.397-3.468 2.872-7.235 2.912-11.452v-.002c.027-2.416 1.66-4.09 3.64-4.203a3.642 3.642 0 012.719 1.005zM118.383 46.516a1.718 1.718 0 00.077 3.433l.527-.012a1.717 1.717 0 10-.077-3.432l-.527.011zm-3.462 1.795a3.502 3.502 0 013.423-3.579l.527-.011a3.5 3.5 0 11.156 7l-.527.012a3.502 3.502 0 01-3.579-3.422z'
      fill='#9D97AB'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M118.292 39.845a1.718 1.718 0 10.069 3.434l.527-.01a1.717 1.717 0 00-.069-3.434l-.527.01zm-3.467 1.788a3.503 3.503 0 013.431-3.572l.527-.01a3.503 3.503 0 11.14 7.002l-.527.01a3.502 3.502 0 01-3.571-3.43z'
      fill='#9D97AB'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M118.362 32.843a1.717 1.717 0 10.077 3.433l.527-.012a1.717 1.717 0 10-.077-3.433l-.527.012zm-3.462 1.795a3.501 3.501 0 013.422-3.579l.527-.012a3.502 3.502 0 01.156 7.001l-.527.012a3.5 3.5 0 01-3.578-3.422zM74.61 57.941a1.338 1.338 0 011.87.091l16.465 17.77a1.339 1.339 0 01-.072 1.891l-3.03 2.807a1.338 1.338 0 01-1.82-1.964l2.05-1.897-14.665-15.826-5.18 4.604a1.338 1.338 0 11-1.778-2l6.16-5.476z'
      fill='#9D97AB'
    />
    <path
      d='M74.886 68.047a1.786 1.786 0 100-3.57 1.786 1.786 0 000 3.57zM101.484 59.719a1.786 1.786 0 100-3.572 1.786 1.786 0 000 3.572z'
      fill='#9D97AB'
    />
    <path
      d='M93.848 21.406s-2.932 2.287 0 8.071c-7.656-2.088-8.157-8.05-8.157-8.05H71.104a2.148 2.148 0 01-2.148-2.149V3.15a2.147 2.147 0 012.148-2.148h29.306a2.143 2.143 0 012.148 2.148v16.13a2.132 2.132 0 01-.627 1.52 2.146 2.146 0 01-1.521.627h-6.398l-.164-.02z'
      stroke='#F3EFF1'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M99.081 28.332a1.5 1.5 0 011.5-1.5h9.224a1.5 1.5 0 110 3h-9.224a1.5 1.5 0 01-1.5-1.5zM99.081 33.285a1.5 1.5 0 011.5-1.5h5.271a1.5 1.5 0 110 3h-5.271a1.5 1.5 0 01-1.5-1.5zM90.02 40.533c0-.739.599-1.338 1.338-1.338h10.541a1.338 1.338 0 110 2.676H91.358c-.74 0-1.339-.599-1.339-1.338zM90.02 44.838c0-.739.599-1.338 1.338-1.338h5.27a1.338 1.338 0 010 2.677h-5.27c-.74 0-1.339-.6-1.339-1.339zM90.02 49.099c0-.74.599-1.339 1.338-1.339h10.541a1.338 1.338 0 110 2.677H91.358c-.74 0-1.339-.6-1.339-1.338z'
      fill='#9D97AB'
    />
  </Svg>
)

export default ShareDefaultSvg
